import { update } from 'lodash'
import client from '../client'
import { exportFile } from '../requestDownloadFile';

export default {
  getPublishers: data => {
    return client.get('seller/associate/publisher', { params: data }).then(res => res.data)
  },
  getPublishersByBrandId: data => {
    return client.get('seller/associate/publishergetPublisherDetail/byBrandId', { params: data }).then(res => res.data)
  },
  getPublisherDetail: data => {
    return client.get('seller/associate/publisher/commission', { params: data }).then(res => res.data)
  },
  getPublisherDetailByBrandId: data => {
    return client.get('seller/associate/publisher/brandId', { params: data }).then(res => res.data)
  },
  getPublisherHistory: data => {
    return client.get('seller/associate/publisher/commission/detail', { params: data }).then(res => res.data)
  },
  updatePublisherCommission: data => {
    return client.post('seller/associate/publisher/commission/save', data).then(res => res.data)
  },
  updatePublisherCommissionBatch:data=>{
    return client.post('seller/associate/publisher/commission/save/batch', data).then(res => res.data)
  },
  getPublisherDetailByPublisherId: data => {
    return client.get(`seller/associate/publisher/byPublisherId?publisherId=${data.id}`, ).then(res => res.data)
  },
   downloadProductTemplate: () => {
   return exportFile('seller/settings/downloadProductTemplate', {}, 'asin_template.csv');
  },
  uploadProduct: data => {
    return client.post('seller/settings/uploadProduct', data).then(res => res.data)
  },
  getActiveData: data => {
    return client.post(`seller/associate/publisher/activeData`,data ).then(res => res.data)
  },
  getAcceptedAsins: data => {
    return client.post(`seller/cc/campaigns/publishers/accepted-asins`,data ).then(res => res.data)
  },
  getActiveProducts: data => {
    return client.get(`seller/associate/publisher/active`,{ params: data } ).then(res => res.data)
  },
  getPromotionProductCategoryList: data => {
    return client.get(`seller/associate/publisher/product-categories`,{ params: data } ).then(res => res.data)
  },
  getPromotionMethodsList: data => {
    return client.get(`seller/associate/publisher/promotion-methods`,{ params: data } ).then(res => res.data)
  },
}